import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { StyledFlexDiv } from "../../../../styles/MainStyles";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/Check.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/Close.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/icons/ArrowRight.svg";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import { useTachDocWorkflow } from "../../../../context/TachDocumentContext";
import ModalViewTach from "../../DocumentTach/ModalViewTach";
import StatusPill from "../StatusPill/StatusPill";
import { ActionsWrapper } from "../../../../styles/pages/Workflows/OvertimeActions";
import ModalActionTach from "../../DocumentTach/ModalActionTach";
import WorkflowService from "../../../../service/Docente/WorkflowService";
import GenericUtils from "../../../../utils/GenericUtils";
import ModalAlertTach from "../../DocumentTach/ModalAlertTach";

const WORKFLOW_FILTER_STATUS = "PENDING";

type TachDocumentActionsProps = {
    workflow: any;
};

const TachDocumentActions: React.FC<TachDocumentActionsProps> = ({
    workflow,
}) => {
    const { instance } = useMsal();
    const { setJustification } = useTachDocWorkflow();
    const { BtnOutlinePrimary } = ButtonStyles;
    const [showApproveModal, setShowApproveModal] = useState<boolean>(false);
    const [showCancelModal, setShowCancelModal] = useState<boolean>(false);
    const [showViewModal, setShowViewModal] = useState<boolean>(false);
    const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
    const [urlPdf, setUrlPdf] = useState<string>("");

    const handleCloseApproveModal = () => {
        setShowApproveModal(false);
    };

    const handleCloseCancelModal = () => {
        setShowCancelModal(false);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
    };

    const handleCloseAlertModal = () => {
        setShowAlertModal(false);
    };

    const approveTachModal = (
        <ModalActionTach
            open={showApproveModal}
            onClose={handleCloseApproveModal}
            workflow={workflow}
            cancelModal={false}
        />
    );

    const cancelTachModal = (
        <ModalActionTach
            open={showCancelModal}
            onClose={handleCloseCancelModal}
            workflow={workflow}
            cancelModal
        />
    );

    const viewTachModal = (
        <ModalViewTach
            open={showViewModal}
            onClose={handleCloseViewModal}
            url={urlPdf}
        />
    );

    const alertModal = (
        <ModalAlertTach open={showAlertModal} onClose={handleCloseAlertModal} />
    );

    const getUrlPdf = async () => {
        const response = await WorkflowService.getDocTachById(
            instance,
            workflow.workflowProcessoId
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setUrlPdf(response.data.url);
            setShowViewModal(true);
        } else {
            setShowAlertModal(true);
        }
    };

    const viewTachButton = (
        <StyledDefaultButtonLink
            variant="link"
            style={{ fontWeight: 600 }}
            onClick={() => getUrlPdf()}
        >
            <ArrowRightIcon style={{ fill: "#8A0538" }} />
            Visualizar TACH
        </StyledDefaultButtonLink>
    );

    return (
        <div>
            <StyledFlexDiv style={{ gap: 20 }}>
                {workflow.status === WORKFLOW_FILTER_STATUS ? (
                    <>
                        {viewTachButton}
                        <BtnOutlinePrimary
                            style={{ fontWeight: 600 }}
                            onClick={() => {
                                setShowCancelModal(true);
                                setJustification("");
                            }}
                        >
                            <CloseIcon style={{ fill: "#8A0538" }} />
                            Cancelar TACH
                        </BtnOutlinePrimary>
                        <BtnOutlinePrimary
                            style={{ fontWeight: 600 }}
                            onClick={() => {
                                setShowApproveModal(true);
                                setJustification("");
                            }}
                        >
                            <CheckIcon style={{ fill: "#8A0538" }} />
                            Aprovar TACH
                        </BtnOutlinePrimary>
                    </>
                ) : (
                    <ActionsWrapper>
                        <StatusPill
                            status={workflow.status}
                            key={workflow.id}
                        />
                        {viewTachButton}
                    </ActionsWrapper>
                )}
            </StyledFlexDiv>
            {showApproveModal && approveTachModal}
            {showCancelModal && cancelTachModal}
            {showViewModal && urlPdf && viewTachModal}
            {showAlertModal && alertModal}
        </div>
    );
};

export default TachDocumentActions;
